/* eslint-disable @typescript-eslint/ban-ts-ignore */

import React from "react";

import { Preview } from "@creatomate/preview";

// @ts-ignore
import { signUpload } from "@culturehq/client";
import { ImageField } from "@culturehq/components";
import { MediaFieldValue } from "@culturehq/components/dist/components/form/MediaField";

import { useAWSUpload } from "app/hooks";
import { errorService, getSubdomain, t } from "app/utils";

import { IMAGE_TYPE } from "components/stories/video-studio/utils/constants";
import { usePreviewTime } from "components/stories/video-studio/contexts/TimeContext";
import createElement from "../../../utils/creatomate/createElement";

interface ImageFileSelectorProps {
  onMediaUploaded: (modifications: Record<string, any>) => {};
  onUploading: (value: boolean) => void;
  preview: Preview;
  uploading: boolean;
}

const ImageFileSelector: React.FC<ImageFileSelectorProps> = ({
  onMediaUploaded, onUploading, preview, uploading
}) => {
  const { time } = usePreviewTime();

  const { waitForS3 } = useAWSUpload();

  const handleOnImageAdd = async (media: MediaFieldValue, finalVersion: boolean) => {
    if (
      media instanceof File
      && media.type.startsWith(IMAGE_TYPE)
      && finalVersion
    ) {
      if (!uploading) {
        onUploading(true);
        const tempUrl = `https://${getSubdomain()}.culturehq.com/${Date.now()}`;
        try {
          await preview.cacheAsset(tempUrl, media);
        } catch (error) {
          errorService.error(`Error caching the file: ${error}`);
        }
        const newElementId = await createElement({
          type: "image",
          source: tempUrl,
          time: Math.round((time + Number.EPSILON) * 100) / 100,
          fit: "contain",
          name: `media-${media.name}`
        }, preview);
        onUploading(false);

        const mediaUrl = await signUpload(media, (_mediaProgress: number) => {});
        await waitForS3(2000, { [`${newElementId}.source`]: mediaUrl }, onMediaUploaded);
      }
    }
  };

  return (
    <ImageField
      name="new-image"
      onChange={handleOnImageAdd}
      asButtonView
      buttonLabel={t("Add Image")}
      icon="image"
      className="MediaField"
    >
      <></>
    </ImageField>
  );
};

export default ImageFileSelector;
